var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"auction-status",class:'status-' + _vm.status.toLowerCase()},[_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("default")],2),_c('div',{staticClass:"badge-auction-type"},[_vm._v(_vm._s(_vm.auctionType.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }